class ConfirmationModal {
    constructor() {
      this.isConfirmationModalOpen = false;
    }
  
    get() {
      return this.isConfirmationModalOpen;
    }
  
    set(value) {
      this.isConfirmationModalOpen = value;
    }
  }
  
  export const confirmationModalObject = new ConfirmationModal(); 